import { render, staticRenderFns } from "./epmallbrand.vue?vue&type=template&id=b9615708"
import script from "./epmallbrand.vue?vue&type=script&lang=js"
export * from "./epmallbrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports